// extracted by mini-css-extract-plugin
export default {"sidenav":"NavBar_sidenav__4niTz","image":"NavBar_image__tSiS1"};